<template>
  <transition
    name="zm-zoom-in-top"
    @after-enter="handleEnter"
    @after-leave="handleLeave"
  >
    <div
      class="zm-table-column-panel"
      v-clickoutside="handleOutsideClick"
      v-show="showPopper"
      role="application"
    >
      <div class="zm-table-column-panel__group" role="dialog">
        <div class="zm-table-column-panel__group-list">
          <zm-checkbox-list
            v-model="displayedProps"
            :items="columns"
            :column-count="columnCount"
            :span="span"
            ref="checkboxList"
            stop-key-board-event
          >
            <template slot-scope="props">
              <span>{{props.item.displayName}}</span>
              <zm-tooltip
                v-if="props.item.tip" :content="props.item.tip.content"
                :placement="props.item.tip.placement || 'top'"
              >
                <zm-button type="icon" icon="zm-icon-info-outline" :aria-label="props.item.tip.ariaLabel" />
              </zm-tooltip>
            </template>
          </zm-checkbox-list>
          <div class="zm-table-column-panel__link" v-if="link">
            <a :href="link.href">
              <span class="zm-icon-add mgr-sm"></span>
              {{link.text}}
            </a>
          </div>
        </div>
        <div class="pdl-md pdr-md">
          <zm-button
            type="primary"
            class="mgt-md"
            @click="handleConfirm"
            size="mini"
            :disabled="displayedProps && displayedProps.length === 0"
            aria-label="Confirm Filters"
          >
            {{ t('table.confirmFilter') }}
          </zm-button>
        </div>
      </div>
    </div>
  </transition>
</template>

<script>
  import Popper from '../../utils/vue-popper';
  // import { PopupManager } from '../../utils/popup';
  import Locale from '../../mixins/locale';
  import Clickoutside from '../../utils/clickoutside';
  import Dropdown from './dropdown';
  import ZmCheckboxList from '../checkbox-list';
  import ZmButton from '../button';
  import AriaDialog from '../../utils/aria-dialog';
  import AriaUtils from '../../utils/aria-utils';

  const EVENT_CONFIRM = 'confirm';

  export default {
    name: 'ZmTableColumnPanel',

    mixins: [Popper, Locale],

    components: {
      ZmCheckboxList,
      ZmButton
    },

    directives: {
      Clickoutside
    },

    props: {
      placement: {
        type: String,
        default: 'bottom-end'
      }
    },

    data() {
      return {
        table: null,
        cell: null,
        displayedProps: null,
        ignore: null,
        tip: null,
        count: null
      };
    },

    computed: {
      columns() {
        const ignore = this.ignore;
        const tip = this.tip;
        return this.table.store.states._columns.filter((column) => {
          return column.type !== 'selection' && column.type !== 'expand' && column.type !== 'index' && !column.fixed && (!ignore || ignore.indexOf(column.property) === -1);
        }).map((column) => {
          return {
            displayName: column.label,
            label: column.property,
            ariaLabel: column.label,
            tip: tip ? tip[column.property] : false
          };
        });
      },
      link() {
        return this.table.initDisplayedColumn.link;
      },
      columnCount() {
        return this.count ? this.count : 1;
      },
      span() {
        return 24 / this.columnCount;
      }
    },

    mounted() {
      this.popperElm = this.$el;
      this.referenceElm = this.cell;
    },

    methods: {
      handleConfirm() {
        this.$emit(EVENT_CONFIRM, this.displayedProps);
        this.handleOutsideClick();
      },

      handleOutsideClick() {
        setTimeout(() => {
          this.showPopper = false;
        }, 16);
      },

      handleEnter() {
        document.body.addEventListener('keydown', this.handleKeydown);
        this.$refs.checkboxList.reset();
        const focusAfterClosed = document.activeElement;
        this.ariaDialog = new AriaDialog(this.$el, focusAfterClosed);
      },

      handleLeave() {
        document.body.removeEventListener('keydown', this.handleKeydown);
        this.ariaDialog && this.ariaDialog.closeDialog();
      },

      handleKeydown(event) {
        const keyCode = event.keyCode;
        const keys = AriaUtils.keys;
        const checkboxList = this.$refs.checkboxList;
        // console.log(event.target);
        switch (keyCode) {
          case keys.esc:
            this.handleOutsideClick();
            break;
          case keys.down:
            if (checkboxList.bottom || checkboxList.leave) {
              this.ariaDialog.focusNext();
            }
            event.preventDefault();
            event.stopPropagation();
            break;
          case keys.up:
            if (checkboxList.bottom || checkboxList.leave) {
              this.ariaDialog.focusPrevious();
            }
            event.preventDefault();
            event.stopPropagation();
            break;
        }
      }
    },

    watch: {
      showPopper(val) {
        if (val) {
          Dropdown.open(this);
          this.closeBySwapedColumn = null;
        } else {
          Dropdown.close(this);
        }
      },
      cell(newVal) {
        this.updatePopperReference(newVal);
      }
    }
  };
</script>

<style lang="scss">
@import "./panel-style";
</style>
